(function(){
  function initEchoPage(root){
    var mainImg = root.querySelector('[data-echo-main-image]');
    var lightbox = root.querySelector('[data-echo-lightbox]');
    var lightboxImg = root.querySelector('[data-echo-lightbox-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-echo-thumb]'));
    function showThumb(btn){
      var src = btn.getAttribute('data-full-src');
      var srcset = btn.getAttribute('data-full-srcset');
      var alt = btn.getAttribute('data-alt') || '';
      if(mainImg && src){
        mainImg.setAttribute('src', src);
        if(srcset){ mainImg.setAttribute('srcset', srcset); }
        mainImg.setAttribute('alt', alt);
      }
      thumbs.forEach(function(item){ item.setAttribute('aria-current','false'); });
      btn.setAttribute('aria-current','true');
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
    root.querySelectorAll('[data-echo-thumb]').forEach(function(btn){
      btn.addEventListener('click', function(){
        showThumb(btn);
      });
    });
    if(mainImg && thumbs.length > 1){
      var touchStartX = 0;
      mainImg.addEventListener('touchstart', function(e){
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      mainImg.addEventListener('touchend', function(e){
        var delta = e.changedTouches[0].clientX - touchStartX;
        if(Math.abs(delta) < 45) return;
        var currentIndex = thumbs.findIndex(function(item){ return item.getAttribute('aria-current') === 'true'; });
        if(currentIndex < 0) currentIndex = 0;
        var nextIndex = delta < 0 ? currentIndex + 1 : currentIndex - 1;
        if(nextIndex < 0) nextIndex = thumbs.length - 1;
        if(nextIndex >= thumbs.length) nextIndex = 0;
        showThumb(thumbs[nextIndex]);
      }, { passive: true });
    }
    root.querySelectorAll('[data-echo-open-lightbox]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(!mainImg || !lightbox || !lightboxImg) return;
        lightboxImg.setAttribute('src', mainImg.getAttribute('src'));
        lightboxImg.setAttribute('alt', mainImg.getAttribute('alt') || 'Shoprider Echo+ product image');
        lightbox.setAttribute('aria-hidden','false');
      });
    });
    root.querySelectorAll('[data-echo-close-lightbox]').forEach(function(btn){
      btn.addEventListener('click', function(){ if(lightbox) lightbox.setAttribute('aria-hidden','true'); });
    });
    if(lightbox){
      lightbox.addEventListener('click', function(e){ if(e.target === lightbox) lightbox.setAttribute('aria-hidden','true'); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') lightbox.setAttribute('aria-hidden','true'); });
    }
    root.querySelectorAll('.echo-accordion details').forEach(function(detail){
      detail.addEventListener('toggle', function(){
        if(detail.open){
          var group = detail.closest('.echo-accordion');
          if(group){ group.querySelectorAll('details').forEach(function(other){ if(other !== detail) other.removeAttribute('open'); }); }
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.echo-plus-page').forEach(initEchoPage);
  });
})();
